import React from "react";

const NotifyBill = () => {
  return (
    <svg
      width="120"
      height="120"
      viewBox="0 0 120 120"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <rect width="120" height="120" fill="url(#pattern0)" />
      <defs>
        <pattern
          id="pattern0"
          patternContentUnits="objectBoundingBox"
          width="1"
          height="1"
        >
          <use xlinkHref="#image0" transform="scale(0.0104167)" />
        </pattern>
        <image
          id="image0"
          width="96"
          height="96"
          xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGAAAABgCAQAAABIkb+zAAACvUlEQVR42u2aPUtDMRSG38FeETfboWJHURAFN3+Bg3RTf4QdFMciwgWF4lYQnR0c9De4uWhBBxdnBcUqimCLg/gRBy1oPi73I0kTPe9Zk5z3uTfJPTcEIJFIpL+pAEs4RhttHGMJgW/2h3AG9iPOMOTX0/9t/wvBo7ewKNhnYFj0B6AhBWj4A9CSArT8AWCKIAAC+B8Ak0qASbeN92AGu7hX2mdguMcuZtDjnvkBrKAZaf1nNLGCAXfM92FVsfNHRQur6HPB/jQuE5vvxCWmu120beMjtX0Ghg9sd6/IG8RRJvOdOMJgN+wPZ5g64lQatm1/BDdKO+9ooIZZTKAIAChiArOooYF3ZZ8bjNi0X8SFwsg1qigp+5VQxbWi58U3rgX14kRq4QGVGAsyQAUP0v4n6LUDsCVNv4987BHy2JeOsWXDflmS+BULicdZwKtkpLJp+/2Svec5ZdoyniX7Ub9ZgDXJ0y9neJviW1gzab8gqXkqmUasSGqkgjmAdcnSjftTo5K4nNfNVT63wsZZyAxQEDbVW1PV0Xyi6RP/d1KcRvNmAPa4NFeRTyo+QIArru2emQn0xKWpJvqxj1KVa/tkYhJNCSVbSRtASSjzpvQDLCc86Ux2pMKfpi7rB9jhUtS0AtS41jv6AQ65FHNaAea41of6AfgaaFwrwLhQE2nXI5cirxUgz7V+1A/wwqUItAIEXOsX8we23W5PAATgOoBr4xMAARAAARAAfcgIgAAIgAAIgD5kBEAA6RRaBwjN2jcPoBEhtHKFkplCCC3dAWVmEEJtl5rSRui3/UwIbthPjeCO/ZQIzLEgAAKwDUAikdLpLnIp3rkPcBoJcOo+wEYkwIb7AKPSK8WdS7KjPqyCuhKg7scyzuFAav8AOV92ohw28fbL/Bs2/bH/pTHUcY422jhHHWP0fSGRzOgTsDLg2tqZJPAAAAAASUVORK5CYII="
        />
      </defs>
    </svg>
  );
};

export default NotifyBill;
